var render = function render(_c,_vm){return _c('footer',{staticClass:"the-footer flex-wrap justify-between",class:_vm.classes},[_c('span',[_vm._v("COPYRIGHT © "+_vm._s(new Date().getFullYear())+" Huanchu")])])
}
var staticRenderFns = []

export { render, staticRenderFns }